import store from './store'

class Notifications {

    constructor({
        interval
    }) {
        this.interval = interval
        this._intervalFc = null
        this.status = 'stop'
    }

    fetch() {
        return store.dispatch('notifications/fetch')
    }

    start() {
        if( this.status == 'desactivate' ) {
            return;
        }
        console.log('START noty');
        this._intervalFc = setInterval(() => {
            this.fetch()
        }, this.interval)
        this.status = 'start'
    }

    stop() {
        console.log('STOP noty refresh');
        clearInterval(this._intervalFc)
        this._intervalFc = null
        this.status = 'stop'
    }

    desactivate() {
        console.log('DESACTIVATE noty refresh');
        this.stop()
        this.status = 'desactivate'
    }

}

let instance = new Notifications({
    interval: 20000
    //interval: 2000
});

export default instance
